import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { RegistrationService } from '@site-shared/data';
import { Action } from '@site-shared/domain';
import { PublicService } from '@site-shared/public';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RegistrationActionResolver implements Resolve<Action> {
	constructor(
		private readonly _publicService: PublicService,
		private readonly _registrationService: RegistrationService
	) {}

	public resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Action> {
		this._publicService.segment = route.data['segment'];
		return this._publicService.getActionRequest('name').pipe(
			switchMap(([d, c]) => this._registrationService.getMetaData(d!, c!)),
			take(1)
		);
	}
}
